import { cva } from 'class-variance-authority';

/** Multi-line text control surface. Shares the input's token set, not its module. */
export const controlStyles = cva(
  [
    'w-full rounded-control border bg-surface-raised text-content',
    'transition-colors',
    'placeholder:text-content-subtle',
    'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-content-muted',
  ],
  {
    variants: {
      size: {
        sm: 'px-2.5 py-1.5 text-xs',
        md: 'px-3 py-2 text-sm',
      },
      invalid: {
        true: 'border-critical',
        false: 'border-border hover:border-border-strong',
      },
    },
    defaultVariants: {
      size: 'md',
      invalid: false,
    },
  },
);

/** Label, hint and error text. Grouped so the field shell reads as one unit. */
export const fieldStyles = {
  root: 'flex w-full flex-col gap-1.5',
  label: 'text-sm font-medium text-content',
  hint: 'text-xs text-content-muted',
  error: 'text-xs text-critical',
  visuallyHidden: 'sr-only',
  /** Auto-resize overrides the inline height the hook writes. */
  autoResize: 'resize-none overflow-hidden',
} as const;